import { motion } from 'framer-motion';
import React, { type HTMLInputTypeAttribute } from 'react';
import { type UseFormRegisterReturn } from 'react-hook-form';
import ErrorIcon from '@/public/icons/error.svg';
import styles from './Input.module.scss';

// Props Types
interface InputProps {
	isError?: boolean;
	register: UseFormRegisterReturn<string>;
	settings?: {
		type?: HTMLInputTypeAttribute;
		placeholder?: string;
		dataTestId?: string;
		dataE2e?: string;
		inputMode?:
			| 'none'
			| 'text'
			| 'tel'
			| 'url'
			| 'email'
			| 'numeric'
			| 'decimal'
			| 'search';
	};
	classes?: {
		field?: string;
		input?: string;
		icon?: string;
	};
}

export const Input: React.FC<InputProps> = ({
	isError,
	register,
	settings,
	classes,
}) => {
	const { field, input, icon } = classes ?? {};
	const { type, placeholder, inputMode, dataTestId, dataE2e } = settings ?? {
		type: 'text',
		placeholder: '',
		inputMode: 'text',
		dataTestId: '',
		dataE2e: '',
	};

	return (
		<label
			className={`
				${styles['field']}
				${isError ? styles['field_error'] : ''}
				${field ?? ''}
			`}
		>
			<input
				type={type}
				placeholder={placeholder}
				inputMode={inputMode}
				data-testid={dataTestId}
				data-e2e={dataE2e}
				className={`
					${styles['field__input']}
					${input ?? ''}
				`}
				{...register}
			/>
			<motion.span
				initial={false}
				animate={{
					opacity: isError ? 1 : 0,
					scale: isError ? 1 : 0,
					y: '-50%',
				}}
				transition={{
					type: 'spring',
					duration: 0.5,
				}}
				className={`
					${styles['field__icon']}
					${icon ?? ''}
				`}
			>
				<ErrorIcon className={styles['field__icon-svg']} />
			</motion.span>
		</label>
	);
};
